(function() {
    angular
        .module("app")
        .controller("NoticeModalController", NoticeModalController)

    NoticeModalController.$inject = [
        "$rootScope",
        "$scope",
        "$sce",
        "$uibModalInstance",
        "$state",
        "emailNotice",
        "markNoticeAsRead",
        "previewNotice",
        "noticeService"
    ]

    function NoticeModalController(
        $rootScope,
        $scope,
        $sce,
        $uibModalInstance,
        $state,
        emailNotice,
        markNoticeAsRead,
        previewNotice,
        noticeService
    ){
        "use strict"

        if (previewNotice) {
            $scope.notice = previewNotice
            $scope.asPreview = true
        } else {
            $scope.notice = $rootScope.displayNotice
            $scope.asPreview = false
        }

        $scope.notice.display_publish_on = moment($scope.notice.publish_on).format("MMMM Do, YYYY")

        $scope.emailNotice = () => {
            if (!$scope.asPreview) {
                $uibModalInstance.close(emailNotice($scope.notice.id))
            }
        }

        $scope.markNoticeAsRead = () => {
            if (!$scope.asPreview) {
                $uibModalInstance.close(markNoticeAsRead($scope.notice.id))
            }
        }

        $scope.showAll = () => {
            if (!$scope.asPreview) {
                $uibModalInstance.close($state.go("notices"))
            }
        }

        $scope.close = function() {
            $uibModalInstance.dismiss("cancel")
        }

        setTimeout(() => {
            $scope.$apply(() => {
                const content = noticeService.formatContentForDisplay($scope.notice.content)
                document.getElementById("noticeContent").innerHTML = $sce.trustAsHtml(content)
            })
        }, 5)
    }
})()
